import { useSkillDiscovery } from '~/work/skillDiscovery/hooks';
import { useSWRConfig } from 'swr';
import { useSkillDiscoveryLockedSkillsStore } from '~/work/skillDiscovery/stores';
import { useSelectedItemStore } from '../useSelectedItemStore';

interface UseReloadSkillDiscovery {
  reloadSkillDiscovery: () => void;
}

export const useReloadSkillDiscovery = (): UseReloadSkillDiscovery => {
  const refreshRoot = useSkillDiscovery().mutate;
  const { cache } = useSWRConfig();
  const { clearSkillDiscoveryLockedProblems: clearLockedProblems } =
    useSkillDiscoveryLockedSkillsStore();
  const setSelectedAncestors = useSelectedItemStore(
    state => state.setSelectedAncestors,
  );

  // Wipes out entire swr cache for skillDiscovery.show
  const reloadSkillDiscovery = async (): Promise<void> => {
    clearLockedProblems();

    const mapCache = cache as Map<string, any>;

    for (const key of mapCache.keys()) {
      if (typeof key === 'string' && key.includes('skillDiscovery.show')) {
        mapCache.delete(key);
      }
    }
    refreshRoot();
    setSelectedAncestors([]);
  };

  return { reloadSkillDiscovery };
};
